<template>
  <div>
    <footer class="footer-light mt-5" style="margin-bottom: 0px !important;">
      <section class="section-b-space light-layout mobile-section">
        <div class="container">
          <div class="row footer-theme partition-f">
            <div class="footer-contant">
              <div class="row">

                <div class="footer-social col-xs-6">
                  <ul>

                  </ul>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="sub-title">
                <div class="footer-contant">
                  <ul class="contact-list">
                    <li>
                      (818) 555-5555
                    </li>
                    <li>
                      License: CXX-0000XXX-LIC
                    </li>
                    <li>
                      <i class="fa fa-copyright" aria-hidden="true"></i>2022 Froot Brand. All Right Reserved.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </footer>
  <TapTop/>
  </div>
</template>

<script>
import TapTop from '../widgets/tap-to-top'
export default {
  data() {
    return {
      // result_debit: null,

    }
  },
  components: {
    TapTop
  },
  created() {
  }
}
</script>
<style scoped>
  @font-face {
    font-family: "Helvetica";
    src: local("Helvetica"),
    url('../../assets/fonts/Helvetica.ttf') format("truetype");
  }
  .footer-theme .sub-title .contact-list li{
    font-family: "Helvetica";
  }
</style>
